import { FormPagePropertyItemMailAddress } from 'backend';
import { RE_ENTER_PROPERTY_ID_PREFIX } from 'reEnter';
import { FormPageInputData, MAIL_ADDRESS_PROPERTY_INPUT_TYPE } from 'shared';
import { PropertyItemElement } from '../getPropertyItemElements';

export const getMailddressInputValue = (
  propertyItem: FormPagePropertyItemMailAddress,
  propertyItemElement: PropertyItemElement,
): FormPageInputData => {
  switch (propertyItem.inputFormat.inputType) {
    case MAIL_ADDRESS_PROPERTY_INPUT_TYPE.free: {
      const mailAddressElement = propertyItemElement.mailAddress;
      if (!(mailAddressElement instanceof HTMLInputElement)) {
        return {};
      }
      const mailAddressValue = mailAddressElement.value;

      const reEnterElement = propertyItemElement.reEnter;
      if (
        !propertyItem.reEnter ||
        !(reEnterElement instanceof HTMLInputElement)
      ) {
        return {
          [propertyItem.propertyId]: {
            inputItemType: 'mailAddressFree',
            mailAddress: mailAddressValue,
          },
        };
      }
      return {
        [propertyItem.propertyId]: {
          inputItemType: 'mailAddressFree',
          mailAddress: mailAddressValue,
        },
        [`${RE_ENTER_PROPERTY_ID_PREFIX}${propertyItem.propertyId}`]: {
          inputItemType: 'mailAddressFree',
          mailAddress: reEnterElement.value,
        },
      };
    }
    case MAIL_ADDRESS_PROPERTY_INPUT_TYPE.atSignSeparated: {
      const localElement = propertyItemElement.local;
      const domainElement = propertyItemElement.domain;
      if (
        !(localElement instanceof HTMLInputElement) ||
        !(domainElement instanceof HTMLInputElement)
      ) {
        return {};
      }
      const localValue = localElement.value;
      const domainValue = domainElement.value;

      const reEnterLocalElement = propertyItemElement.reEnterLocal;
      const reEnterDomainElement = propertyItemElement.reEnterDomain;
      if (
        !propertyItem.reEnter ||
        !(reEnterLocalElement instanceof HTMLInputElement) ||
        !(reEnterDomainElement instanceof HTMLInputElement)
      ) {
        return {
          [propertyItem.propertyId]: {
            inputItemType: 'mailAddressAtSignSeparated',
            local: localValue,
            domain: domainValue,
          },
        };
      }
      return {
        [propertyItem.propertyId]: {
          inputItemType: 'mailAddressAtSignSeparated',
          local: localValue,
          domain: domainValue,
        },
        [`${RE_ENTER_PROPERTY_ID_PREFIX}${propertyItem.propertyId}`]: {
          inputItemType: 'mailAddressAtSignSeparated',
          local: reEnterLocalElement.value,
          domain: reEnterDomainElement.value,
        },
      };
    }
    case MAIL_ADDRESS_PROPERTY_INPUT_TYPE.domainPulldown: {
      const localElement = propertyItemElement.local;
      const domainElement = propertyItemElement.domain;
      if (
        !(localElement instanceof HTMLInputElement) ||
        !(domainElement instanceof HTMLSelectElement)
      ) {
        return {};
      }
      const localValue = localElement.value;
      const domainValue = domainElement.value;

      const reEnterLocalElement = propertyItemElement.reEnterLocal;
      const reEnterDomainElement = propertyItemElement.reEnterDomain;
      if (
        !propertyItem.reEnter ||
        !(reEnterLocalElement instanceof HTMLInputElement) ||
        !(reEnterDomainElement instanceof HTMLSelectElement)
      ) {
        return {
          [propertyItem.propertyId]: {
            inputItemType: 'mailAddressDomainPulldown',
            local: localValue,
            domain: domainValue,
          },
        };
      }
      return {
        [propertyItem.propertyId]: {
          inputItemType: 'mailAddressDomainPulldown',
          local: localValue,
          domain: domainValue,
        },
        [`${RE_ENTER_PROPERTY_ID_PREFIX}${propertyItem.propertyId}`]: {
          inputItemType: 'mailAddressDomainPulldown',
          local: reEnterLocalElement.value,
          domain: reEnterDomainElement.value,
        },
      };
    }
  }
};
